/* eslint-disable */
export default {
  currentCall: 'Chamada atual',
  viewCalls: 'Exibir chamadas',
  view: 'Exibir',
  incomingCall: '{numberOf} chamada recebida',
  incomingCalls: '{numberOf} chamadas recebidas',
  callOnHold: '{numberOf} chamada em espera',
  callsOnHold: '{numberOf} chamadas em espera',
  otherDeviceCall: '{numberOf} chamada em outros dispositivos',
  otherDeviceCalls: '{numberOf} cham. em outros disp.',
} as const;

// @key: @#@"currentCall"@#@ @source: @#@"Current Call"@#@
// @key: @#@"viewCalls"@#@ @source: @#@"View Calls"@#@
// @key: @#@"view"@#@ @source: @#@"View"@#@
// @key: @#@"incomingCall"@#@ @source: @#@"{numberOf} Incoming Call"@#@
// @key: @#@"incomingCalls"@#@ @source: @#@"{numberOf} Incoming Calls"@#@
// @key: @#@"callOnHold"@#@ @source: @#@"{numberOf} Call On Hold"@#@
// @key: @#@"callsOnHold"@#@ @source: @#@"{numberOf} Calls On Hold"@#@
// @key: @#@"otherDeviceCall"@#@ @source: @#@"{numberOf} Call on other devices"@#@
// @key: @#@"otherDeviceCalls"@#@ @source: @#@"{numberOf} Calls on other devices"@#@
